import { HoloBackground } from "@/components/HoloBackground";

export function LegalShell({ eyebrow, title, intro, children }) {
  return (
    <div className="vault-bg">
      <section className="relative overflow-hidden border-b border-white/8">
        <HoloBackground />
        <div className="relative mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8">
          <span className="overline mb-3 block">{eyebrow}</span>
          <h1 className="font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">{title}</h1>
          {intro && <p className="mt-4 max-w-2xl text-slate-300">{intro}</p>}
        </div>
      </section>
      <section className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10">{children}</div>
      </section>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <div>
      <h2 className="mb-3 font-display text-xl font-bold text-white">{title}</h2>
      <div className="space-y-3 leading-relaxed text-slate-300">{children}</div>
    </div>
  );
}

export function Todo({ children }) {
  return (
    <span className="rounded border border-amber-500/30 bg-amber-500/10 px-1.5 py-0.5 text-sm font-medium text-amber-200">
      {children || "ÚDAJ NA DOPLNENIE"}
    </span>
  );
}

export function Notice({ children }) {
  return (
    <div className="rounded-xl border border-violet-glow/25 bg-violet-glow/10 px-4 py-3 text-sm leading-relaxed text-violet-100">
      {children}
    </div>
  );
}
